/* eslint no-shadow:0 */
import axios from 'axios';
import {
  upsertRenewalClient as apiUpsertRenewalClient,
  saveRenewalCar as apiSaveRenewalCar,
  buyPlan as apiBuyPlan,
  getRenewalProgress as apiGetRenewalProgress,
  requestRenewalStkPush as apiRequestRenewalStkPush,
  pollUntilComplete as apiPollUntilComplete,
} from '@/services/renewalApi';

const data = {
  qoute: {},
  renewalClient: {},
  dpRenewal: {},
  renewalBatch: null,
  renewalPaymentStatus: null,
  renewalPolicyResult: null,
};
const getters = {
  fetchQoute: (state) => state.qoute,
  renewalClient: (state) => state.renewalClient,
  dpRenewal: (state) => state.dpRenewal,
  renewalBatch: (state) => state.renewalBatch,
  renewalPaymentStatus: (state) => state.renewalPaymentStatus,
  renewalPolicyResult: (state) => state.renewalPolicyResult,
};

const mutations = {
  updateQuotation(state, payload) {
    state.qoute = payload;
  },
  updateRenewalClient(state, payload) {
    state.renewalClient = payload;
  },
  setdpRenewal(state, val) {
    state.dpRenewal = { ...state.dpRenewal, ...val };
  },
  cleardpRenewal(state) {
    state.dpRenewal = {};
  },
  SET_RENEWAL_BATCH(state, batch) {
    state.renewalBatch = batch;
  },
  SET_RENEWAL_PAYMENT_STATUS(state, status) {
    state.renewalPaymentStatus = status;
  },
  SET_RENEWAL_POLICY_RESULT(state, result) {
    state.renewalPolicyResult = result;
  },
  CLEAR_RENEWAL(state) {
    state.renewalBatch = null;
    state.renewalPaymentStatus = null;
    state.renewalPolicyResult = null;
  },
};
const actions = {
  fetchRenewalClient: async (context, id) => {
    await axios.get(`/customer/gis/clients/renewalClients?batchNo=${id}`).then(async (response) => {
      context.commit('updateRenewalClient', response.data.object);
    });
  },
  fetchQuotation: async (context, id) => {
    await axios.get(`/customer/quotation?batchNo=${id}`).then((response) => {
      if (response.data.success) {
        context.commit('updateQuotation', response.data.data);
      }
    });
  },

  async initiateRenewalBatch({ commit }, dto) {
    const result = await apiUpsertRenewalClient(dto);
    if (result.success) {
      commit('SET_RENEWAL_BATCH', result.data);
    }
    return result;
  },

  async saveRenewalCarDetails(_, { batchId, cars }) {
    return apiSaveRenewalCar(batchId, cars);
  },

  async confirmRenewalPlan({ state }, dto) {
    const batchId = dto.batchId || state.renewalBatch?.batchId;
    if (!batchId) return { success: false, message: 'No active renewal batch' };
    return apiBuyPlan(dto);
  },

  async payRenewal({ commit, state }, { customerPhoneNumber, payableAmount, policyNo }) {
    const batch = state.renewalBatch;
    const batchId = batch?.batchId;
    if (!batchId) return { success: false, message: 'No active renewal batch' };

    commit('SET_RENEWAL_PAYMENT_STATUS', 'INITIATING');
    const stkResult = await apiRequestRenewalStkPush({
      batchId,
      payableAmount,
      customerPhoneNumber,
      policyNo,
    });
    if (!stkResult.success) {
      commit('SET_RENEWAL_PAYMENT_STATUS', 'FAILED');
      return stkResult;
    }

    commit('SET_RENEWAL_PAYMENT_STATUS', 'POLLING');
    const pollResult = await apiPollUntilComplete(stkResult.data.paymentId);
    commit('SET_RENEWAL_PAYMENT_STATUS', pollResult.paymentStatus);

    if (pollResult.success) {
      const progress = await apiGetRenewalProgress(batchId);
      commit('SET_RENEWAL_POLICY_RESULT', progress.data || null);
    }
    return pollResult;
  },

  clearRenewal({ commit }) {
    commit('CLEAR_RENEWAL');
  },
};

export default {
  namespaced: true,
  state: data,
  getters,
  actions,
  mutations,
};
